(() => {
  'use strict';
  const root = document.body.dataset.root.replace(/\/?$/, '/');
  const currency = document.body.dataset.currency || 'AUD';
  const money = value => {
    const format=config.moneyFormat;
    const token=typeof format==='string' && format.match(/\{\{\s*(amount(?:_no_decimals)?(?:_with_(?:comma|apostrophe|space)_separator)?)\s*\}\}/);
    if(token && currency===(config.shopCurrency || currency)){
      const decimals=Number(value)%100===0?0:2;
      let amount=new Intl.NumberFormat('en-US',{minimumFractionDigits:decimals,maximumFractionDigits:decimals}).format(value/100);
      if(token[1].includes('comma_separator'))amount=amount.replace(/,/g,'~').replace(/\./g,',').replace(/~/g,'.');
      if(token[1].includes('apostrophe_separator'))amount=amount.replace(/,/g,"'");
      if(token[1].includes('space_separator'))amount=amount.replace(/,/g,' ');
      return format.replace(token[0],amount).replace(/<[^>]*>/g,'').replace(/&nbsp;/g,' ').replace(/&amp;/g,'&');
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en-AU',{style:'currency',currency,minimumFractionDigits:Number(value)%100===0?0:2,maximumFractionDigits:2}).formatToParts(value/100).map(part=>part.type==='currency' && part.value==='$' ? (currency==='AUD'?'A$':`${currency} `) : part.value).join('');
  };
  const config = JSON.parse(document.querySelector('[data-commerce-config]')?.textContent || '{}');
  const uiText=(key,fallback,values={})=>String(config.uiLabels?.[key] || fallback).replace(/\{(\w+)\}/g,(match,name)=>values[name]??match);
  const productNoun = config.productNoun || 'item';
  const productNounPlural = config.productNounPlural || 'items';
  const lineSignature = item => JSON.stringify([Number(item.variant_id), item.selling_plan_allocation?.selling_plan?.id || null, Object.entries(item.properties || {}).sort(([a],[b]) => a.localeCompare(b))]);
  const readDiscounts = content => {
    try { return JSON.parse(content?.querySelector('[data-cart-discounts]')?.textContent || '[]'); } catch { return []; }
  };
  let activeRequest = false;
  let persistentError = '';
  let pendingFocus = null;
  async function api(path, data) {
    const controller=new AbortController();
    const timer=setTimeout(()=>controller.abort(),15000);
    try {
      const response = await fetch(root + path, {signal:controller.signal,method:data ? 'POST':'GET', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, ...(data ? {body:JSON.stringify(data)}:{})});
      let result;
      try { result = await response.json(); } catch { throw new Error('We could not connect to your cart. Please refresh the page and try again.'); }
      if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Your bag could not be updated. Please try again.');
      return result;
    } catch(caught) {
      if(caught.name==='AbortError')throw new Error('The store took too long to respond. Check your bag before trying again.');
      throw caught;
    } finally {clearTimeout(timer);}
  }
  function error(message) {
    persistentError=message;
    const targets = document.querySelectorAll('[data-product-error], [data-cart-error]');
    targets.forEach(target => {target.textContent=message;target.hidden=!message;});
    if (message) window.HearthUI?.toast(message);
  }
  function renderNativePrice(priceNode, originalNode, variant) {
    if (!priceNode) return;
    const valid = variant && Number.isFinite(Number(variant.price)) && Number(variant.price) >= 0;
    priceNode.textContent = valid ? money(variant.price) : uiText('unavailable','Unavailable');
    if (originalNode) {
      const compare = valid && Number(variant.compare_at_price) > Number(variant.price);
      originalNode.hidden = !compare;
      if (compare) originalNode.textContent = money(variant.compare_at_price);
    }
  }
  function purchaseItem(product, options, quantity) {
    const variant = bottleVariant(product, options);
    if (!variant) throw new Error('That option combination is not offered. Please choose again.');
    if (!variant.available) throw new Error('That option combination is sold out. Please choose again.');
    if (Number(product.variant_count) > product.variants.length) throw new Error('The product options could not be fully loaded. Please refresh the page.');
    const amount = Number(quantity);
    if (!Number.isSafeInteger(amount) || amount < 1) throw new Error('Please enter a whole quantity of 1 or more.');
    return {id:variant.id, quantity:amount};
  }
  function variantMedia(product, variant) {
    const maps=config.variantImages || [];
    const match=maps.find(item=>variant?.sku && item.sku===variant.sku) || maps.find(item=>item.options.length===variant?.options.length && item.options.every((value,index)=>value===variant.options[index])) || (product.variants?.length===1 ? maps.find(item=>item.options.length===0) : null);
    const colourIndex = product.options.findIndex(name => /colo[u]?r/i.test(name));
    return {variantId:variant?.id, mediaId:variant?.media_id, image:variant?.image || match?.image, colour:colourIndex>=0 ? variant?.options[colourIndex] : '', alt:`${product.title || ''} ${variant?.options.join(' / ') || ''}`.trim()};
  }
  async function loadVariantMedia() {
    if(!config.variantMediaUrl)return;
    const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),4000);
    try {
      const response=await fetch(config.variantMediaUrl,{signal:controller.signal,credentials:'same-origin'});
      if(!response.ok)throw Error('Variant photos could not be loaded');
      const map=await response.json();
      if(map.version!==1 || !Array.isArray(map.variants))throw Error('Invalid variant photo map');
      const base=new URL(config.variantMediaUrl,location.href);
      config.variantImages=map.variants.filter(item=>Array.isArray(item.options)&&typeof item.asset==='string'&&/^[a-zA-Z0-9][a-zA-Z0-9._-]*$/.test(item.asset)).map(item=>({...item,image:new URL(item.asset,base).href}));
    } catch { console.warn('Variant photos unavailable; native product photos will be used.'); }
    finally {clearTimeout(timer);}
  }
  const sectionRequest = {sections:['cart-panel'],sections_url:location.pathname};
  function parseSection(html) {
    if(!html)return null;
    const content=new DOMParser().parseFromString(html,'text/html').querySelector('[data-cart-content]');
    if(!content)return null;
    return {content,discounts:readDiscounts(content)};
  }
  async function cartSection() {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(root + '?sections=cart-panel', {signal:controller.signal, credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Please open your bag to check the latest total.');
      let sections;
      try { sections = await response.json(); } catch { throw new Error('We could not load your cart. Please refresh the page and try again.'); }
      if (!sections['cart-panel']) throw new Error('Please open your bag to check the latest total.');
      const parsed=parseSection(sections['cart-panel']);
      if(!parsed)throw new Error('Please open your cart to check the latest total.');
      return parsed;
    } finally { clearTimeout(timer); }
  }
  // Prices and discounts in the bag are always authoritative Shopify totals.
  // No stored welcome code, synthetic bundle, or discount mutation is applied.
  async function refreshAfterMutation(response=null) {
    return refreshCart(false,response);
  }
  function captureFocus() {
    const active = document.activeElement;
    const scope = active?.closest('[data-cart-content]');
    const line = active?.closest('[data-line-key]');
    const control = active?.matches('[data-bottle-option]') ? `[data-bottle-option="${active.dataset.bottleOption}"]` : active?.matches('[data-quantity-delta]') ? `[data-quantity-delta="${active.dataset.quantityDelta}"]` :
      ['data-cart-variant','data-line-quantity','data-remove-line','data-upgrade-line','data-upgrade-variant','data-checkout'].find(name => active?.hasAttribute(name));
    return scope ? {scope, key:line?.dataset.lineKey, variant:line?.dataset.variantId, index:[...scope.querySelectorAll('[data-line-key]')].indexOf(line), control:control?.startsWith('[') ? control : control ? `[${control}]` : null} : null;
  }
  function restoreFocus(state) {
    if (!state?.scope?.isConnected) return;
    const lines = [...state.scope.querySelectorAll('[data-line-key]')];
    const line = lines.find(item => item.dataset.lineKey === state.key) || lines.find(item => item.dataset.variantId === state.variant) || lines[Math.min(Math.max(state.index, 0), lines.length - 1)];
    const target = (state.key ? line?.querySelector(state.control || 'a') : state.scope.querySelector(state.control || 'a')) || state.scope.querySelector('[data-checkout],a,button');
    target?.focus();
  }
  async function refreshCart(open=false, response=null) {
    const {content,discounts}=parseSection(response?.sections?.['cart-panel']) || await cartSection();
    let cart;
    try{cart=JSON.parse(content.querySelector('[data-cart-state]')?.textContent || 'null');}catch{}
    if(!cart || !Number.isFinite(cart.item_count))cart=await api('cart.js');
    document.querySelectorAll('[data-cart-content]').forEach(target => {
      const editing=[...target.querySelectorAll('[data-cart-edit]')].map(node=>node.open);
      target.innerHTML=content.innerHTML;
      target.querySelectorAll('[data-cart-edit]').forEach((node,index)=>node.open=Boolean(editing[index]));
    });
    document.querySelectorAll('[data-cart-count]').forEach(badge => {badge.textContent=cart.item_count;badge.hidden=cart.item_count===0;});
    document.querySelectorAll('[data-open-cart]').forEach(button => button.setAttribute('aria-label', `Shopping bag, ${cart.item_count} ${cart.item_count===1?'item':'items'}`));
    const count = document.querySelector('[data-cart-dialog-count]'); if(count) count.textContent=cart.item_count;
    renderBedControls();
    renderUpgrades();
    if (persistentError) error(persistentError);
    // Replaced forms must remain locked until the current transaction completes.
    if (activeRequest) lockControls();
    if (open) window.HearthUI.showDialog(document.querySelector('[data-cart-dialog]'));

    return cart;
  }
  const lockedControls = new Map();
  function lockControls() {
    document.querySelectorAll('[data-product-section] button,[data-product-section] input,[data-product-section] select,[data-cart-form] button,[data-cart-form] input,[data-cart-form] select,[data-cart-form] textarea,[data-closing-add]').forEach(control => {
      if (!lockedControls.has(control)) lockedControls.set(control, control.disabled);
      control.disabled = true;
    });
    document.querySelectorAll('[data-cart-content]').forEach(node => node.setAttribute('aria-busy','true'));
  }
  async function transaction(action) {
    if (activeRequest) { window.HearthUI?.toast('Your bag is still updating. Please wait a moment.'); return; }
    pendingFocus = captureFocus();
    const opener = document.activeElement;
    activeRequest = true; error(''); lockControls();
    document.querySelectorAll('[data-cart-loading]').forEach(node => node.hidden=false);
    try {
      await action(opener);
    } catch (caught) {
      error(caught.message || 'Your bag could not be updated. Please check its current contents.');
      try { await refreshCart(); } catch { error(`${caught.message} Open your bag again to confirm its current contents.`); }
    } finally {
      activeRequest = false;
      lockedControls.forEach((disabled,control) => {if(control.isConnected)control.disabled=disabled;});
      lockedControls.clear();
      document.querySelectorAll('[data-cart-content]').forEach(node => node.removeAttribute('aria-busy'));
      document.querySelectorAll('[data-cart-loading]').forEach(node => node.hidden=true);
      document.dispatchEvent(new Event('commerce-idle'));
      restoreFocus(pendingFocus); pendingFocus=null;
    }
  }
  function bottleVariant(product, options) {
    return product?.variants.find(variant=>variant.options.length===options.length && variant.options.every((value,index)=>value===options[index]));
  }
  function bottleChange(product, line, action) {
    const current=product?.variants.find(variant=>Number(variant.id)===Number(line.variant_id));
    if(!current || Number(product.id)!==Number(line.product_id))throw new Error('Please open this product to change its options.');
    if(action.variantId){const chosen=product.variants.find(v=>String(v.id)===String(action.variantId));if(!chosen?.available)throw new Error('That option combination is unavailable. Your item has been kept.');return chosen;}
    if(!Number.isInteger(action.index) || action.index<0 || action.index>=current.options.length)throw new Error('Please choose the options again.');
    const options=[...current.options];options[action.index]=action.value;
    const chosen=bottleVariant(product,options);
    if(!chosen)throw new Error('That option combination is not offered. Your item has been kept.');
    if(!chosen.available)throw new Error('That option combination is sold out. Your item has been kept.');
    return chosen;
  }
  function renderBedControls() {
    const product=config.packs?.single;
    document.querySelectorAll('[data-cart-bed-options]').forEach(container=>{
      container.replaceChildren();
      const line=container.closest('[data-line-key]');
      const current=Number(line?.dataset.productId)===Number(product?.id) && product?.variants.find(v=>Number(v.id)===Number(line.dataset.variantId));
      const editor=container.closest('[data-cart-edit]');if(editor)editor.hidden=!current || product?.variants.length<=1;
      if(!current || product?.variants.length<=1)return;
      const quantity=Number(line.querySelector('[data-line-quantity]')?.value);
      if(quantity>1){const note=document.createElement('p');note.className='cart-bed-note';note.textContent=`Changes apply to all ${quantity} ${productNounPlural} in this row.`;container.append(note);}
      const row=document.createElement('div');row.className='cart-bed-row';
      const label=document.createElement('label');label.append('Choose option');
      const select=document.createElement('select');select.dataset.cartVariant='';
      product.variants.forEach(variant=>{const option=new Option(`${variant.options.join(' / ')} · ${money(variant.price)}${variant.available?'':' — sold out'}`,variant.id);option.selected=variant.id===current.id;option.disabled=!variant.available;select.add(option);});
      label.append(select);row.append(label);container.append(row);
    });
  }
  function renderUpgrades() {
    const product=config.packs?.single;
    const offered=new Set();
    document.querySelectorAll('[data-cart-upgrade]').forEach(container=>{
      container.replaceChildren();if(!product || product.variants.length<=1)return;const scope=container.closest('[data-cart-content]');
      const line=container.closest('[data-line-key]');
      if(offered.has(scope) || Number(line?.dataset.productId)!==Number(product?.id))return;
      const candidates=product.variants.filter(v=>v.available);if(!candidates.length)return;
      offered.add(scope);scope.querySelectorAll('[data-cart-extra]').forEach(node=>node.hidden=true);
      const label=document.createElement('label');label.textContent=`Add another ${productNoun}`;
      const select=document.createElement('select');select.dataset.upgradeVariant='';
      candidates.forEach(variant=>select.add(new Option(`${variant.options.join(' / ')} · ${money(variant.price)}`,variant.id)));
      label.append(select);
      const button=document.createElement('button');button.type='button';button.className='upgrade-button';button.dataset.upgradeLine='';
      const update=()=>{const variant=candidates.find(v=>String(v.id)===select.value);button.textContent=`Add ${productNoun} · ${money(variant.price)}`;};
      select.addEventListener('change',update);update();container.append(label,button);
    });
  }
  async function replaceLine(original, variant) {
    const signature=lineSignature(original);
    if(variant && Number(variant.id)===Number(original.variant_id))return;
    if(!variant){
      try{await api('cart/change.js',{id:original.key,quantity:0});}
      catch(caught){const cart=await api('cart.js');if(cart.items.some(item=>lineSignature(item)===signature))throw caught;}
      return;
    }
    const marker=`${Date.now()}-${Math.random().toString(36).slice(2)}`;
    let additionError;
    try{await api('cart/add.js',{items:[{id:variant.id,quantity:original.quantity,properties:{...original.properties,_variant_change:marker}}]});}
    catch(caught){additionError=caught;}
    let cart=await api('cart.js');
    let oldLine=cart.items.find(item=>lineSignature(item)===signature);
    const added=cart.items.find(item=>item.properties?._variant_change===marker);
    // A 422 or lost response can accompany a partial add. Never retry the add.
    if(!added || added.quantity!==original.quantity || additionError){
      if(oldLine && added)await api('cart/change.js',{id:added.key,quantity:0});
      throw new Error('The item change could not be completed. Please review your bag before trying again.');
    }
    if(!oldLine || oldLine.quantity!==original.quantity){
      if(oldLine)await api('cart/change.js',{id:added.key,quantity:0});
      throw new Error('Your bag changed while this item was updating. Please review its current contents.');
    }
    try{await api('cart/change.js',{id:oldLine.key,quantity:0});}
    catch(caught){
      // A failed response does not prove the write failed. Roll back only after
      // an authoritative read still shows the original item.
      cart=await api('cart.js');
      oldLine=cart.items.find(item=>lineSignature(item)===signature);
      const replacement=cart.items.find(item=>item.properties?._variant_change===marker);
      if(oldLine){
        if(replacement)await api('cart/change.js',{id:replacement.key,quantity:0});
        throw new Error('The item change could not be completed. Your original item is still in your bag. Please check it before trying again.');
      }
      if(!replacement)throw caught;
    }
  }
  async function changeBottle(line, action) {
    const cart=await api('cart.js');const original=cart.items.find(item=>item.key===line.dataset.lineKey);
    if(!original)throw new Error('Your bag has changed. Please review it before changing this item.');
    const variant=bottleChange(config.packs?.single,original,action);
    await replaceLine(original,variant);await refreshAfterMutation();
  }
  async function upgradeLine(line) {
    const product=config.packs?.single;
    const variantId=Number(line.querySelector('[data-upgrade-variant]')?.value);
    const chosen=product?.variants.find(v=>Number(v.id)===variantId && v.available);
    if(!chosen)throw new Error('That item is unavailable. Please choose again.');
    const response=await api('cart/add.js',{items:[{id:chosen.id,quantity:1}],...sectionRequest});await refreshAfterMutation(response);
  }

  function initialSelection(data, requestedPack, requestedVariant) {
    const product = data.single;
    const variant = product?.variants.find(item=>String(item.id)===String(requestedVariant)) || product?.variants.find(item=>item.available) || product?.variants[0];
    return {pack:'single',variant};
  }
  function stockPresentation(variant,threshold) {
    if(!variant?.available)return {purchase:'',closing:'',source:'unavailable'};
    const tracked=variant.inventory!==null && variant.inventory!==undefined && Number.isFinite(Number(variant.inventory));
    const actual=tracked ? Math.max(0,Number(variant.inventory)) : null;
    if(tracked && actual>0 && actual<=Number(threshold))return {purchase:uiText('stock_low','{count} {units} available',{count:actual,units:productNounPlural}),closing:'',source:'inventory'};
    const label=tracked ? (actual===0 ? uiText('stock_available','Available to order') : uiText('stock_in','In stock')) : uiText('stock_available','Available to order');
    return {purchase:label,closing:'',source:tracked?'inventory':'availability'};
  }
  function offerActive(variant,enabled,endAt,now=Date.now()) {
    const end=Date.parse(endAt || '');
    const datedSunday=/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(endAt || '') && new Date(endAt.slice(0,10)+'T12:00:00Z').getUTCDay()===0;
    return Boolean(datedSunday && enabled && variant?.available && Number(variant.compare_at_price)>Number(variant.price) && Number.isFinite(end) && now<=end);
  }
  function discountPercent(variant) {
    const price=Number(variant?.price),compare=Number(variant?.compare_at_price);
    return variant && Number.isFinite(price) && price>=0 && Number.isFinite(compare) && compare>price ? Math.round((compare-price)*100/compare) : null;
  }
  function offerMessage(variant,template) {
    const discount=discountPercent(variant);
    return discount===null ? '' : String(template || '').replaceAll('{discount}',String(discount));
  }
  // The requested fixed headline must never promise more than the native saving.
  function announcementActive(variant,enabled,endAt,now=Date.now()) {
    return offerActive(variant,enabled,endAt,now) && discountPercent(variant)>=30;
  }
  let announcementVariant;
  function renderAnnouncements() {
    document.querySelectorAll('[data-sale-announcement]').forEach(node=>{
      node.hidden=!announcementActive(announcementVariant,node.dataset.promotionEnabled==='true',node.dataset.promotionEndAt);
    });
  }
  function renderDiscount(badge,variant) {
    if(!badge)return;
    const valid=variant && Number.isFinite(Number(variant.price)) && Number(variant.price)>=0 && Number.isFinite(Number(variant.compare_at_price)) && Number(variant.compare_at_price)>Number(variant.price);
    badge.hidden=!valid;
    badge.textContent=valid ? `You Save ${money(Number(variant.compare_at_price)-Number(variant.price))}` : '';
  }
  function initialise(rootNode=document) {
    rootNode.querySelectorAll('[data-product-section]:not([data-commerce-ready])').forEach(section=>{
      section.dataset.commerceReady='true';
      const data=JSON.parse(section.querySelector('[data-product-data]')?.textContent || '{}');
      if(!data.single)return;
      const form=section.querySelector('.purchase-form');
      const initial=initialSelection(data,section.dataset.initialPack,section.dataset.initialVariant);
      const product=data.single;
      let selectedVariant=initial.variant;
      let gallerySelection='';
      if(!selectedVariant || !form)return;
      let selectedOptions=[...selectedVariant.options];
      form.querySelector('[data-variant-id]').disabled=false;
      const selects=section.querySelector('[data-variant-options]');
      const quantityInput=form.querySelector('[data-purchase-quantity]');
      const addButton=section.querySelector('[data-add-cart]');
      const closingButtons=[...document.querySelectorAll('[data-closing-add]')];
      closingButtons.forEach(button=>{button.hidden=false;button.onclick=()=>form.requestSubmit();});
      document.querySelectorAll('[data-closing-fallback]').forEach(link=>link.hidden=true);
      function renderOptions() {
        selects.replaceChildren();
        if(product.variants.length===1)return;
        product.options.forEach((name,index)=>{
          const values=[...new Set(product.variants.map(variant=>variant.options[index]))];
          // Constant dimensions are not a choice; keep their value in the tuple.
          if(values.length<=1)return;
          const label=document.createElement('label');label.append(name);
          const select=document.createElement('select');select.dataset.productOption=String(index);
          values.forEach(value=>{const option=new Option(value,value);option.selected=selectedOptions[index]===value;select.add(option);});
          label.append(select);selects.append(label);
        });
      }
      const offerNode=section.querySelector('[data-offer-deadline]');
      if(offerNode)setInterval(()=>{offerNode.hidden=!offerActive(selectedVariant,section.dataset.promotionEnabled==='true',section.dataset.promotionEndAt);},1000);
      function updateQuantity() {
        const value=Number(quantityInput.value);
        form.querySelectorAll('[data-purchase-quantity-delta]').forEach(button=>{button.disabled=activeRequest || (Number(button.dataset.purchaseQuantityDelta)<0 && (!Number.isFinite(value) || value<=1));});
      }
      function update() {
        const options=[...selectedOptions];
        selects.querySelectorAll('select').forEach(select=>options[Number(select.dataset.productOption)]=select.value);
        selectedVariant=bottleVariant(product,options);
        selectedOptions=options;
        const completeCatalogue=!product.variant_count || product.variant_count<=product.variants.length;
        const available=Boolean(selectedVariant?.available && completeCatalogue);
        form.querySelector('[data-variant-id]').value=selectedVariant?.id || '';
        addButton.disabled=!available || activeRequest;
        addButton.textContent=!completeCatalogue ? uiText('catalogue_incomplete','Please contact us to choose this product') : selectedVariant ? (available?uiText('add_to_cart','ADD TO CART'):uiText('sold_out','Sold out')):uiText('options_missing','Combination unavailable');
        const stickyAdd=section.querySelector('[data-sticky-add]');
        if(stickyAdd){stickyAdd.disabled=!available || activeRequest;stickyAdd.textContent=addButton.textContent;}
        const stock=section.querySelector('[data-stock-note]');
        const stockCopy=stockPresentation(selectedVariant,section.dataset.lowStock);
        announcementVariant=selectedVariant;renderAnnouncements();
        const offer=section.querySelector('[data-offer-deadline]');
        if(offer){offer.textContent=offerMessage(selectedVariant,offer.dataset.offerMessage);offer.hidden=!offerActive(selectedVariant,section.dataset.promotionEnabled==='true',section.dataset.promotionEndAt);}
        // Only genuine tracked inventory belongs here; the offer is never inventory.
        stock.textContent=stockCopy.source==='inventory' ? stockCopy.purchase : '';stock.hidden=!stock.textContent;stock.dataset.stockSource=stockCopy.source;
        closingButtons.forEach(button=>{button.disabled=!available || activeRequest;button.textContent=addButton.textContent;});
        selects.querySelectorAll('select').forEach(select=>{
          [...select.options].forEach(option=>{
            const tuple=[...selectedOptions];tuple[Number(select.dataset.productOption)]=option.value;
            const candidate=bottleVariant(product,tuple);
            option.textContent=option.value+(candidate ? candidate.available ? '' : ' — sold out' : ' — unavailable');
            // Keep choices reachable when multiple dimensions must change together.
          });
        });
        renderNativePrice(section.querySelector('[data-single-price]'),section.querySelector('[data-single-original]'),selectedVariant);
        renderDiscount(section.querySelector('[data-discount-badge]'),selectedVariant);
        renderNativePrice(section.querySelector('[data-sticky-price]'),section.querySelector('[data-sticky-original]'),selectedVariant);
        const mediaSelection=String(selectedVariant?.id || '');
        const explicitVariant=new URL(location.href).searchParams.has('variant');
        if(selectedVariant && mediaSelection!==gallerySelection){
          if(gallerySelection || explicitVariant)section.querySelector('[data-gallery]')?.dispatchEvent(new CustomEvent('show-variant',{detail:variantMedia(product,selectedVariant)}));
          gallerySelection=mediaSelection;
        }
        if(selectedVariant && (location.pathname===product.url || location.pathname===root+product.url.replace(/^\//,''))) {
          const url=new URL(location.href);url.searchParams.set('variant',selectedVariant.id);history.replaceState(null,'',url);
        }
        updateQuantity();
      }
      section.addEventListener('change',event=>{if(event.target.matches('[data-product-option]'))update();if(event.target.matches('[data-purchase-quantity]'))updateQuantity();});
      section.addEventListener('click',event=>{
        const control=event.target.closest('[data-purchase-quantity-delta]');
        if(!control || control.disabled)return;
        const current=Number(quantityInput.value);
        quantityInput.value=String(Math.max(1,(Number.isSafeInteger(current)?current:1)+Number(control.dataset.purchaseQuantityDelta)));
        updateQuantity();
      });
      form.addEventListener('submit',event=>{
        event.preventDefault();
        if(activeRequest || addButton.disabled)return;
        let item;
        try{item=purchaseItem(product,selectedOptions,quantityInput.value);}catch(caught){error(caught.message);return;}
        window.HearthUI.showDialog(document.querySelector('[data-cart-dialog]'));
        transaction(async()=>{
          const response=await api('cart/add.js',{items:[item],...sectionRequest});
          await refreshAfterMutation(response);
        });
      });
      section.querySelector('[data-sticky-add]')?.addEventListener('click',()=>form.requestSubmit());
      const sticky=section.querySelector('[data-sticky-purchase]');
      const mobilePurchase=window.matchMedia("(max-width:767px)");
      let primaryVisible=true,primaryBelow=true,closingVisible=false;
      const syncSticky=()=>{sticky.hidden=primaryVisible || (!mobilePurchase.matches && primaryBelow) || closingVisible;};
      mobilePurchase.addEventListener("change",syncSticky);
      const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.target===addButton){primaryVisible=mobilePurchase.matches ? entry.intersectionRatio>=1 : entry.isIntersecting;primaryBelow=entry.boundingClientRect.top>0;}else closingVisible=entry.isIntersecting;});syncSticky();},{threshold:[0,1]});
      observer.observe(addButton);const closing=document.querySelector('.closing-offer .button');if(closing)observer.observe(closing);
      document.addEventListener('commerce-idle',update);
      renderOptions();update();
    });
  }
  document.addEventListener('click',event=>{
    const extra=event.target.closest('[data-add-upsell]');
    if(extra){transaction(async()=>{const response=await api('cart/add.js',{items:[{id:Number(extra.dataset.addUpsell),quantity:1}],...sectionRequest});await refreshAfterMutation(response);});return;}
    const upgrade=event.target.closest('[data-upgrade-line]');
    if(upgrade){transaction(()=>upgradeLine(upgrade.closest('[data-line-key]')));return;}
    const opener=event.target.closest('[data-open-cart]');
    if(opener){event.preventDefault();window.HearthUI.showDialog(document.querySelector('[data-cart-dialog]'),opener);transaction(()=>refreshCart(false));return;}
    const delta=event.target.closest('[data-quantity-delta]');
    const removal=event.target.closest('[data-remove-line]');
    if(delta || removal){
      event.preventDefault();
      const line=(delta || removal).closest('[data-line-key]');
      const input=line.querySelector('[data-line-quantity]');
      const quantity=removal?0:Math.max(0,Number(input.value)+Number(delta.dataset.quantityDelta));
      transaction(async()=>{const response=await api('cart/change.js',{id:line.dataset.lineKey,quantity,...sectionRequest});await refreshAfterMutation(response);});
    }
  });
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-cart-variant]')){transaction(()=>changeBottle(event.target.closest('[data-line-key]'),{variantId:event.target.value}));return;}
    if(event.target.matches('[data-bottle-option]')){transaction(()=>changeBottle(event.target.closest('[data-line-key]'),{index:Number(event.target.dataset.bottleOption),value:event.target.value}));return;}
    if(event.target.matches('[data-line-quantity]'))transaction(async()=>{
      const response=await api('cart/change.js',{id:event.target.dataset.key,quantity:Math.max(0,Math.floor(Number(event.target.value)||0)),...sectionRequest});await refreshAfterMutation(response);
    });
  });
  document.addEventListener('submit',event=>{
    const form=event.target.closest('[data-cart-form]');
    if(!form)return;
    event.preventDefault();
    if(activeRequest)return;
    // Native checkout uses the current server cart without a redundant update request.
    const checkoutForm=document.createElement('form');checkoutForm.method='post';checkoutForm.action=root+'cart';checkoutForm.hidden=true;
    const checkout=document.createElement('input');checkout.type='hidden';checkout.name='checkout';checkout.value='Checkout';checkoutForm.append(checkout);document.body.append(checkoutForm);
    HTMLFormElement.prototype.submit.call(checkoutForm);
  });
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
  loadVariantMedia().finally(()=>{announcementVariant=initialSelection(config.packs || {},'single',new URL(location.href).searchParams.get('variant')).variant;renderAnnouncements();initialise();renderBedControls();renderUpgrades();});
  setInterval(renderAnnouncements,1000);
})();
